module.exports = __webpack_public_path__ + "static/media/plan-mas-gigas-libres.89872b1f.svg";